<ng-container *transloco="let t; read: 'target-editor'">
  <div class="mt-3">
    <p-messages severity="info">
      <ng-template pTemplate>
        <app-form-field-help [control]="type">
          <ng-container form-field-help-hint>
            {{ t(hasEventWorker ? 'workersOrderDisabledWarning' : 'workersOrderInfoText') }}
          </ng-container>
        </app-form-field-help>
      </ng-template>
    </p-messages>
  </div>
  <form [formGroup]="form">
    <div class="order-selector">
      <p-selectButton
        [allowEmpty]="false"
        [disabled]="hasEventWorker"
        [formControl]="type"
        [ngClass]="{ 'p-disabled': hasEventWorker }"
        [options]="orderByOptions"
      >
        <ng-template let-item pTemplate="item">{{ t(item.label) }}</ng-template>
      </p-selectButton>

      <app-form-field-help [control]="type">
        <ng-container form-field-help-hint>
          {{ t(type.value === OrderByType.explicit ? 'specifiedOrderHelpText' : 'longestIdleTimeHelpText') }}
        </ng-container>
      </app-form-field-help>
    </div>
  </form>
</ng-container>
